module.exports = __webpack_public_path__ + "img/fetch API.ee3263d9.png";